import { useState } from 'react';
import HierarchyNodeForm from './HierarchyNodeForm';
import TopicElementList from './TopicElementList';
import AiTopicGenerationPanel from './AiTopicGenerationPanel';
import { LEVELS_BY_KEY, TOPIC_HOST_LEVEL_KEYS } from './courseLevels';

// A Topic can now be attached directly under any of 5 levels, not just
// Lesson - the GET response nests whichever one relation object the topic
// actually uses (backend read convention), so which field is non-null both
// tells us the host level AND gives its display name "for free", no extra
// lookup needed. Worth surfacing since a topic's attachment depth is no
// longer always the same, and might not be obvious from a scrolled tree.
function deriveHostInfo(topic) {
   for(const key of TOPIC_HOST_LEVEL_KEYS) {
      if(topic[key]) return { levelKey: key, name: topic[key].name };
   }
   return null;
}

// Linked exercises are no longer a separate panel - TopicElementList now
// renders them interleaved with content blocks/containers as just another
// top-level entry kind (see that file's own header comment), addable from
// the same picker, in whatever order the topic is filled in.
export default function TopicWorkspace({ topic, courseId, onSave }) {
   const hostInfo = deriveHostInfo(topic);
   const [aiRefresh, setAiRefresh] = useState(0);

   return (
      <div className='topic-workspace'>
         {hostInfo ? (
            <div className='topic-workspace-breadcrumb'>
               Розташовано в: <strong>{LEVELS_BY_KEY[hostInfo.levelKey].label} «{hostInfo.name}»</strong>
            </div>
         ) : ''}
         <div className='topic-workspace-top-row'>
            <div className='topic-workspace-form-col'>
               <HierarchyNodeForm node={topic} onSave={onSave} title={LEVELS_BY_KEY.topic.label} levelKey='topic' />
            </div>
            <div className='topic-workspace-ai-col'>
               <AiTopicGenerationPanel topicId={topic.id} onGenerated={() => setAiRefresh((prev) => prev + 1)} />
            </div>
         </div>
         <TopicElementList topicId={topic.id} courseId={courseId} refreshSignal={aiRefresh} />
      </div>
   );
}
